import { getApiClient, initializeApiClient } from "../apiService";
export const AddOtherMainSubSectors = async (SecondarySectors) => {
    await initializeApiClient();
    const apiClient = await getApiClient();
    const response = await apiClient.post("api/AI_SecondarySectors/AddAI_SecondarySectors", {
        aI_SubSectorId: SecondarySectors.aI_SubSectorId,
        aI_MainSectorId: SecondarySectors.aI_MainSectorId,
        aI_ApplicationInformationId: SecondarySectors.aI_ApplicationInformationId
    });

    return response
}